module.exports = __webpack_public_path__ + "img/T1C_xh_18.dde13348.png";